import React from "react";
import styles from "./ErrorPage.module.scss";
import { ReactComponentPropsBase } from "../../base-props/ReactComponentPropsBase";
import BlockContainer from "components/layout/BlockContainer/BlockContainer";
import { Icon, ImdiLogo } from "SiteComponents";
import CTA, { CTAProps } from "components/base/CTA/CTA";
import { useSite } from "src/utils/useSite";
import useHeroBackground from "src/utils/use-hero-background/useHeroBackground";
import classNames from "classnames";
import { LinkProps } from "src/base-props/LinkProps";
import IconMS from "components/utils/IconMS/IconMS";

export interface ErrorPageProps extends ReactComponentPropsBase {
  heading: string;
  message: string;
  primaryLink: CTAProps;
  secondaryLink?: CTAProps;
  statusCode: number;
  statusText?: string;
  loginLinks?: {
    title: string;
    linkList: LinkProps[];
  };
}

const ErrorPage: React.FC<ErrorPageProps> = ({
  heading,
  message,
  primaryLink,
  secondaryLink,
  statusCode,
  statusText,
  loginLinks,
}) => {
  const site = useSite();
  const backgroundClass = useHeroBackground();

  return (
    <main className={styles.errorPage} id="main-content">
      <div className={backgroundClass}>
        <BlockContainer
          className={classNames(styles.errorPageBlock, {
            [styles.serverError]: statusCode === 500,
          })}
          verticalPadding
        >
          {statusCode && statusCode !== 500 && site && (
            <Icon
              className={styles.errorPageBlockImage}
              name={`${statusCode}_${site}`}
            />
          )}
          <div className={styles.errorPageBlockText}>
            {statusText && <p className={styles.statusText}>{statusText}</p>}
            <h1>{heading}</h1>
            <p className={styles.message}>{message}</p>
            {(primaryLink?.text || secondaryLink?.text) && (
              <div className={styles.buttonContainer}>
                {primaryLink?.text && <CTA size="small" {...primaryLink} />}
                {secondaryLink?.text && (
                  <CTA theme="secondary" size="small" {...secondaryLink} />
                )}
              </div>
            )}
            {statusCode === 500 && (
              <>
              {loginLinks && loginLinks.linkList && loginLinks.linkList.length > 0 && (
                <div className={styles.linkListContainer} key={loginLinks.title}>
                  {loginLinks.title && <h2>{loginLinks.title}</h2>}
                  <ul className={styles.linkList}>
                    {loginLinks.linkList.map(link => (
                      <li key={link.text}>
                        <a
                          href={link.url}
                          target={link.target}
                          className={styles.link}
                        >
                          {link.text}
                          {link.target === "_blank" && (
                            <IconMS name="open_in_new" size="15px" />
                          )}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              <a
                href={"https://imdi.no"}
                aria-label={"Lenke til imdi"}
                className={styles.logo}
              >
                <ImdiLogo className={styles.imdiLogo} withText />
              </a>
              </>
            )}

            </div>
        </BlockContainer>
      </div>
    </main>
  );
};

export default ErrorPage;
